'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Site(id, created, deleted, account, active, name, url, twoFactorAuth, expressLogin, credentials, signer, realm, scope, system, login, path) {
  this.e1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Lg = null;
  this.Lh = null;
  this.u3 = null;
  this.Lf = false;
  this.kf = null;
  this.n4 = null;
  this.ov = false;
  this.u4 = false;
  this.rT = null;
  this.u6 = null;
  this.ou = null;
  this.qm = null;
  this.rU = null;
  this.u5 = null;
  this.Eg = null;
  this.e1 = id;
  this.Lg = created;
  this.Lh = deleted;
  this.u3 = account;
  this.Lf = active;
  this.kf = name;
  this.n4 = url;
  this.ov = twoFactorAuth;
  this.u4 = expressLogin;
  this.rT = credentials;
  this.u6 = signer;
  this.ou = realm;
  this.qm = scope;
  this.rU = system;
  this.u5 = login;
  this.Eg = path;
}
export { $c_Lpresto_types$Site as $c_Lpresto_types$Site };
$p = $c_Lpresto_types$Site.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Site;
/** @constructor */
function $h_Lpresto_types$Site() {
}
export { $h_Lpresto_types$Site as $h_Lpresto_types$Site };
$h_Lpresto_types$Site.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Site"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.e1;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Lg));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Lh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u3));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Lf ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.kf));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.n4));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.ov ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.u4 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.rT));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u6));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.ou));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qm));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.rU));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Eg));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 16);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Site)) {
    if ((((this.Lf === x$0.Lf) && (this.ov === x$0.ov)) && (this.u4 === x$0.u4))) {
      var this$1 = this.e1;
      var b = x$0.e1;
      var $x_10 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x = this.Lg;
      var x$2 = x$0.Lg;
      var $x_9 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$3 = this.Lh;
      var x$4 = x$0.Lh;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.u3;
      var x$6 = x$0.u3;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_7 = false;
    }
    if ((($x_7 && (this.kf === x$0.kf)) && (this.n4 === x$0.n4))) {
      var x$7 = this.rT;
      var x$8 = x$0.rT;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.u6;
      var x$10 = x$0.u6;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.ou;
      var x$12 = x$0.ou;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.qm;
      var x$14 = x$0.qm;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.i(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.rU;
      var x$16 = x$0.rU;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.i(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.u5;
      var x$18 = x$0.u5;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.i(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.Eg;
      var x$20 = x$0.Eg;
      return ((x$19 === null) ? (x$20 === null) : x$19.i(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 16;
});
$p.s = (function() {
  return "Site";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.e1;
      break;
    }
    case 1: {
      return this.Lg;
      break;
    }
    case 2: {
      return this.Lh;
      break;
    }
    case 3: {
      return this.u3;
      break;
    }
    case 4: {
      return this.Lf;
      break;
    }
    case 5: {
      return this.kf;
      break;
    }
    case 6: {
      return this.n4;
      break;
    }
    case 7: {
      return this.ov;
      break;
    }
    case 8: {
      return this.u4;
      break;
    }
    case 9: {
      return this.rT;
      break;
    }
    case 10: {
      return this.u6;
      break;
    }
    case 11: {
      return this.ou;
      break;
    }
    case 12: {
      return this.qm;
      break;
    }
    case 13: {
      return this.rU;
      break;
    }
    case 14: {
      return this.u5;
      break;
    }
    case 15: {
      return this.Eg;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E = (function() {
  return this.kf;
});
$p.afQ = (function() {
  return this.n4;
});
$p.ctr = (function() {
  return this.u5;
});
$p.H3 = (function() {
  return ("s#" + this.e1);
});
$p.aeh = (function(nameOrUrl) {
  var lower = nameOrUrl.toLowerCase();
  var this$1 = this.kf;
  var this$2 = this$1.toLowerCase();
  if (((this$2.indexOf(lower) | 0) !== (-1))) {
    return true;
  } else {
    var this$3 = this.n4;
    var this$4 = this$3.toLowerCase();
    return ((this$4.indexOf(lower) | 0) !== (-1));
  }
});
$p.jW = (function() {
  return this.e1;
});
function $isArrayOf_Lpresto_types$Site(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kf)));
}
export { $isArrayOf_Lpresto_types$Site as $isArrayOf_Lpresto_types$Site };
var $d_Lpresto_types$Site = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Site, "presto.types$Site", ({
  kf: 1,
  aH: 1,
  kg: 1,
  ed: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Site as $d_Lpresto_types$Site };
//# sourceMappingURL=presto.types$-Site.js.map
